import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { getConsent, setConsent, OPEN_SETTINGS_EVENT } from '../analytics/consent';

const CookieBanner = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (/ReactSnap/.test(navigator.userAgent)) return undefined;
    if (!getConsent()) setOpen(true);
    const reopen = () => setOpen(true);
    window.addEventListener(OPEN_SETTINGS_EVENT, reopen);
    return () => window.removeEventListener(OPEN_SETTINGS_EVENT, reopen);
  }, []);

  if (!open) return null;

  const choose = (granted) => { setConsent(granted); setOpen(false); };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Slapukų nustatymai"
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:px-6"
    >
      <div className="max-w-5xl mx-auto bg-[#1a4a4f] text-white rounded-2xl shadow-2xl border border-white/10 p-5 sm:p-6 flex flex-col md:flex-row md:items-center gap-5">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="w-6 h-6 text-[#4ade80] flex-shrink-0 mt-0.5" aria-hidden="true" />
          <p className="text-sm text-gray-100 leading-relaxed" data-testid="cookie-banner-text">
            Naudojame būtinuosius slapukus svetainės veikimui. Su jūsų sutikimu taip pat naudojame
            analitinius slapukus (Google Analytics, PostHog), kad suprastume, kaip naudojama svetainė.
            Pasirinkimą bet kada galite pakeisti puslapio apačioje.{' '}
            <Link to="/privatumo-politika#slapukai" className="underline underline-offset-4 text-[#4ade80] hover:text-white" data-testid="cookie-banner-policy-link">
              Privatumo politika
            </Link>
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 md:flex-shrink-0">
          <button
            type="button"
            onClick={() => choose(false)}
            data-testid="cookie-reject-btn"
            className="px-6 py-3 rounded-full text-sm font-medium border border-white/40 text-white hover:bg-white/10 transition-colors"
          >
            Nesutinku
          </button>
          <button
            type="button"
            onClick={() => choose(true)}
            data-testid="cookie-accept-btn"
            className="px-6 py-3 rounded-full text-sm font-medium bg-[#cb4a40] hover:bg-[#b8423a] text-white transition-colors"
          >
            Sutinku
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
